module.exports = __webpack_public_path__ + "static/media/GRU.337ed284.pdf";